<template>
    <div id="123" class="flex flex-none gap-2 justify-end py-3 text-right px-2">
        <span v-if="showSelected"> Выбрано элементов: {{ selectedRows }} </span>
        <span> Всего элементов: {{ totalCount }} </span>
    </div>
</template>

<script>
export default {
    name: 'grid-footer',
};
</script>

<script setup>
import { ref } from 'vue';

defineProps({
    showSelected: {
        type: Boolean,
        default: () => true,
    },
});

const totalCount = ref(0);
const selectedRows = ref(0);

const setTotalCount = (count) => {
    totalCount.value = count;
};

const selectRows = count => {
    selectedRows.value = count;
};

defineExpose({
    setTotalCount,
    selectRows,
    selectedRows,
});
</script>

<style scoped>
:deep(.dx-menu-item-content) {
    display: flex;
    align-items: center;
}
</style>
